import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { getContextReferenceVariableName } from "./getContextReference.js";
import { resolveImportSource } from "./resolveImportSource.js";
import { validateFunction, validateGlobalApi } from "./validations.js";
var GlobalConstants = new Map([["BASE_URL", "BASE_URL"], ["translate", "I18N"], ["translateByRecord", "I18N_TEXT"]]);
export function replaceBindings(path, state, app, options, noWrapping) {
  var _options$modifier;
  var isFunc = path.isFunctionDeclaration();
  if (isFunc && !validateFunction(path.node, state)) {
    return null;
  }
  var replacements = [];
  var visitor = {
    Identifier: function Identifier(idPath) {
      var _options$functionBind, _options$eventBinding, _options$eventBinding2, _options$forEachBindi, _options$forEachBindi2, _options$dataBinding, _options$component;
      if (!idPath.isReferencedIdentifier()) {
        return;
      }
      var shorthand = idPath.parentPath.isObjectProperty() && idPath.parentPath.node.shorthand;
      var varName = idPath.node.name;
      var _iterator = _createForOfIteratorHelper(GlobalConstants),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            globalName = _step$value[0],
            replacement = _step$value[1];
          if (validateGlobalApi(idPath, globalName)) {
            replacements.push({
              type: "id",
              start: idPath.node.start,
              end: idPath.node.end,
              replacement: replacement,
              shorthand: shorthand ? varName : undefined
            });
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var binding = idPath.scope.getBinding(varName);
      if (!binding) {
        var _options$stateBinding;
        if ((_options$stateBinding = options.stateBindings) !== null && _options$stateBinding !== void 0 && _options$stateBinding.includes(varName)) {
          replacements.push({
            type: "id",
            start: idPath.node.start,
            end: idPath.node.end,
            replacement: "CTX.".concat(varName),
            shorthand: shorthand ? varName : undefined
          });
        }
        return;
      }
      var bindingId = binding.identifier;
      if (binding.kind === "module") {
        var isImportDefault = binding.path.isImportDefaultSpecifier();
        if (isImportDefault || binding.path.isImportSpecifier()) {
          var importDecl = binding.path.parentPath.node;
          var importedName;
          if (!isImportDefault) {
            var imported = binding.path.get("imported");
            if (!imported.isIdentifier()) {
              state.errors.push({
                message: "Unsupported import specifier type: ".concat(imported.type),
                node: imported.node,
                severity: "error"
              });
              return null;
            }
            importedName = imported.node.name;
          }
          var source = importDecl.source.value;
          if (source.startsWith(".") || source.startsWith("/")) {
            var _modulePart;
            // Local modules
            var importSource = resolveImportSource(source, state.filePath, app.files);
            var mod = app.modules.get(importSource);
            if ((mod === null || mod === void 0 ? void 0 : mod.moduleType) === "css") {
              if (isFunc) {
                state.errors.push({
                  message: "Css imports are not supported for utils functions",
                  node: idPath.node,
                  severity: "error"
                });
                return;
              }
              if (isImportDefault) {
                replacements.push({
                  type: "id",
                  start: idPath.node.start,
                  end: idPath.node.end,
                  replacement: "CONSTANTS[".concat(JSON.stringify(importSource), "]"),
                  shorthand: shorthand ? varName : undefined
                });
              } else {
                state.errors.push({
                  message: "Named imports are not supported for CSS modules",
                  node: idPath.node,
                  severity: "error"
                });
              }
              return;
            }
            var modulePart;
            if (isImportDefault) {
              modulePart = mod === null || mod === void 0 ? void 0 : mod.defaultExport;
            } else {
              modulePart = mod === null || mod === void 0 ? void 0 : mod.namedExports.get(importedName);
            }
            if (((_modulePart = modulePart) === null || _modulePart === void 0 ? void 0 : _modulePart.type) === "function") {
              replacements.push({
                type: "id",
                start: idPath.node.start,
                end: idPath.node.end,
                replacement: "FN.".concat(modulePart["function"].name),
                shorthand: shorthand ? varName : undefined
              });
            } else {
              state.errors.push({
                message: "Invalid usage: \"".concat(varName, "\""),
                node: idPath.node,
                severity: "error"
              });
            }
          } else {
            // External modules
            switch (source) {
              case "lodash":
                replacements.push({
                  type: "id",
                  start: idPath.node.start,
                  end: idPath.node.end,
                  replacement: isImportDefault ? "_" : "_.".concat(importedName),
                  shorthand: shorthand ? varName : undefined
                });
                break;
              case "moment":
                if (isImportDefault) {
                  replacements.push({
                    type: "id",
                    start: idPath.node.start,
                    end: idPath.node.end,
                    replacement: "moment",
                    shorthand: shorthand ? varName : undefined
                  });
                } else {
                  state.errors.push({
                    message: "Named imports are not supported for \"moment\" module",
                    node: idPath.node,
                    severity: "error"
                  });
                }
                break;
            }
          }
        } else {
          state.errors.push({
            message: "Invalid module binding for \"".concat(varName, "\""),
            node: idPath.node,
            severity: "error"
          });
          return;
        }
      }
      if (isFunc && bindingId === path.node.id) {
        return;
      }
      if ((_options$functionBind = options.functionBindings) !== null && _options$functionBind !== void 0 && _options$functionBind.has(bindingId)) {
        replacements.push({
          type: "id",
          start: idPath.node.start,
          end: idPath.node.end,
          replacement: "FN.".concat(varName),
          shorthand: shorthand ? varName : undefined
        });
        return;
      }
      var specificReplacement;
      switch (bindingId) {
        case (_options$eventBinding = options.eventBinding) === null || _options$eventBinding === void 0 ? void 0 : _options$eventBinding.id:
          specificReplacement = (_options$eventBinding2 = options.eventBinding) !== null && _options$eventBinding2 !== void 0 && _options$eventBinding2.isCallback ? "EVENT.detail" : "EVENT";
          break;
        case (_options$forEachBindi = options.forEachBinding) === null || _options$forEachBindi === void 0 ? void 0 : _options$forEachBindi.item:
          specificReplacement = "ITEM";
          break;
        case (_options$forEachBindi2 = options.forEachBinding) === null || _options$forEachBindi2 === void 0 ? void 0 : _options$forEachBindi2.index:
          specificReplacement = "INDEX";
          break;
        case (_options$dataBinding = options.dataBinding) === null || _options$dataBinding === void 0 ? void 0 : _options$dataBinding.id:
          specificReplacement = "DATA";
          break;
      }
      if (specificReplacement) {
        replacements.push({
          type: "id",
          start: idPath.node.start,
          end: idPath.node.end,
          replacement: specificReplacement,
          shorthand: shorthand ? varName : undefined
        });
        return;
      }
      var localBinding = (_options$component = options.component) === null || _options$component === void 0 ? void 0 : _options$component.bindingMap.get(bindingId);
      if (localBinding) {
        if (localBinding.kind === "state" || localBinding.kind === "resource" || localBinding.kind === "constant" || localBinding.kind === "param" || localBinding.kind === "app" || localBinding.kind === "auth" || localBinding.kind === "location" || localBinding.kind === "query" || localBinding.kind === "pathParams") {
          replacements.push({
            type: "id",
            start: idPath.node.start,
            end: idPath.node.end,
            replacement: localBinding.kind === "app" ? "APP" : localBinding.kind === "auth" ? "SYS" : localBinding.kind === "location" ? "location" : localBinding.kind === "query" ? "QUERY" : localBinding.kind === "pathParams" ? "PATH" : "".concat(options.component.type === "template" ? "STATE" : "CTX", ".").concat(bindingId.name),
            shorthand: shorthand ? varName : undefined
          });
        } else if (localBinding.kind === "context") {
          replacements.push({
            type: "id",
            start: idPath.node.start,
            end: idPath.node.end,
            replacement: "CTX.".concat(getContextReferenceVariableName(localBinding.contextProvider.name, localBinding.contextKey)),
            shorthand: shorthand ? varName : undefined
          });
        } else {
          state.errors.push({
            message: "Invalid usage of ".concat(localBinding.kind, " variable \"").concat(bindingId.name, "\""),
            node: idPath.node,
            severity: "error"
          });
        }
      }
    }
  };
  if (!isFunc) {
    Object.assign(visitor, {
      TSTypeAnnotation: function TSTypeAnnotation(tsPath) {
        replacements.push({
          type: "annotation",
          start: tsPath.node.start,
          end: tsPath.node.end
        });
        tsPath.skip();
      },
      TSTypeParameterInstantiation: function TSTypeParameterInstantiation(tsPath) {
        replacements.push({
          type: "annotation",
          start: tsPath.node.start,
          end: tsPath.node.end
        });
        tsPath.skip();
      },
      TSAsExpression: function TSAsExpression(tsPath) {
        replacements.push({
          type: "annotation",
          start: tsPath.node.expression.end,
          end: tsPath.node.end
        });
        tsPath.skip();
      }
    });
  }
  if (path.isIdentifier()) {
    visitor.Identifier(path);
  }
  path.traverse(visitor);
  replacements.sort(function (a, b) {
    return a.start - b.start;
  });
  var chunks = [];
  var prevStart = path.node.start;
  for (var _i = 0, _replacements = replacements; _i < _replacements.length; _i++) {
    var rep = _replacements[_i];
    chunks.push(state.source.substring(prevStart, rep.start), rep.type === "annotation" ? "" : "".concat(rep.shorthand ? "".concat(rep.shorthand, ":") : "").concat(rep.replacement));
    prevStart = rep.end;
  }
  chunks.push(state.source.substring(prevStart, path.node.end));
  var value = chunks.join("");
  if (isFunc || noWrapping) {
    return value;
  }
  return "<%".concat((_options$modifier = options.modifier) !== null && _options$modifier !== void 0 ? _options$modifier : "", " ").concat(value, " %>");
}
//# sourceMappingURL=replaceBindings.js.map